import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Save, Minus } from "lucide-react";
import { api } from "@/lib/api";
import { apiError } from "@/lib/apiError";
import { useI18n } from "@/lib/i18n";
import { inputClass, labelClass, btnPrimary, btnGhost } from "@/components/Brand";

/** Operator-set scarcity counter shown on the landing hero and every plan card. */
export const EarlyAccessPanel = () => {
  const { t } = useI18n();
  const [form, setForm] = useState({ slots_left: "", slots_total: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/platform/early-access")
      .then((r) => setForm({ slots_left: String(r.data.slots_left), slots_total: String(r.data.slots_total) }))
      .catch(() => {});
  }, []);

  const save = async (next) => {
    setBusy(true);
    try {
      const res = await api.put("/platform/early-access", {
        slots_left: Math.max(0, Number(next?.slots_left ?? form.slots_left) || 0),
        slots_total: Math.max(1, Number(next?.slots_total ?? form.slots_total) || 20),
      });
      setForm({ slots_left: String(res.data.slots_left), slots_total: String(res.data.slots_total) });
      toast.success(t("early_access_saved"));
    } catch (err) {
      toast.error(apiError(err, "Could not save"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="border border-[#2A2A2A] bg-[#0F0F0F] p-7 space-y-6" data-testid="early-access-panel">
      <div>
        <p className="eyebrow">{t("early_access")}</p>
        <p className="mt-2 text-[11px] text-[#707070] max-w-xl">{t("early_access_hint")}</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div>
          <label className={labelClass}>{t("slots_left")}</label>
          <input data-testid="early-access-left-input" type="number" min="0" className={inputClass}
            value={form.slots_left} onChange={(e) => setForm({ ...form, slots_left: e.target.value })} />
        </div>
        <div>
          <label className={labelClass}>{t("slots_total")}</label>
          <input data-testid="early-access-total-input" type="number" min="1" className={inputClass}
            value={form.slots_total} onChange={(e) => setForm({ ...form, slots_total: e.target.value })} />
        </div>
      </div>
      <div className="flex flex-wrap gap-3">
        <button data-testid="early-access-save-btn" disabled={busy} onClick={() => save()} className={btnPrimary}>
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} {t("save")}
        </button>
        <button data-testid="early-access-decrement-btn" disabled={busy || Number(form.slots_left) <= 0}
          onClick={() => save({ slots_left: Number(form.slots_left) - 1 })}
          className={`${btnGhost} disabled:opacity-40`}>
          <Minus size={13} /> {t("slot_taken")}
        </button>
      </div>
    </section>
  );
};
